export const benefitsTypes = {
    SET_BENEFITS: "SET_BENEFITS",
  };